import { Play, Loader2 } from 'lucide-react';
import { chatTheme as th } from '../../theme/chat';

export default function Workspace({ title, description, actions, onRun, runLabel, loading, toolbar, children, footer }) {
  const tb = th.workspace.titleBar;
  return (
    <div className="flex-1 flex flex-col h-full min-w-0 bg-white">
      {/* Title bar */}
      <div className={`${tb.height} flex items-center justify-between px-4 ${tb.border} flex-shrink-0`}>
        <div className="flex items-center gap-2 flex-1 min-w-0">
          <span className={`${tb.title} truncate`}>{title || 'Untitled'}</span>
          {description && <span className={`${tb.description} truncate hidden lg:block`}>&mdash; {description}</span>}
        </div>
        <div className="flex items-center gap-1 flex-shrink-0 ml-3">
          {actions}
          {actions && onRun && <span className={tb.separator} />}
          {onRun && (
            <button onClick={onRun} disabled={loading} className={tb.runBtn}>
              {loading ? <Loader2 size={12} className="animate-spin" /> : <Play size={12} />}
              {loading ? 'Running\u2026' : (runLabel || 'Run')}
            </button>
          )}
        </div>
      </div>

      {/* Toolbar (collapsible content from page) */}
      {toolbar}

      {/* Main content (DataTable) */}
      <div className="flex-1 flex flex-col min-h-0 overflow-hidden">
        {children}
      </div>

      {/* Footer (ReconciliationPanel etc.) */}
      {footer}
    </div>
  );
}
